import { useEffect, useState } from 'react';

import type { JobDetails } from '@xing-com/crate-jobs-helpers';
import { useWindowSize } from '@xing-com/crate-jobs-hooks';

import { Container, Header, ProfileImage, Title } from './sticky-header.styles';
import { StickyMainActions } from './sticky-main-actions';

type Props = {
  show: boolean;
  job: JobDetails;
  headerRef?: HTMLElement;
};

export const StickyHeader: React.FC<Props> = ({ job, show, headerRef }) => {
  const windowSize = useWindowSize();
  const [stickyHeaderWidth, setStickyHeaderWidth] = useState(0);
  const { application, bookmarkState, company, title } = job;

  useEffect(() => {
    setStickyHeaderWidth((headerRef?.offsetWidth ?? 0) + 16); // +16 is to have an extra space so the bottom border exceeds the content
  }, [headerRef, windowSize.width]);

  return (
    <Container
      $isSticky={show}
      $width={stickyHeaderWidth}
      data-testid="job-details-sticky-header"
    >
      <Header>
        <ProfileImage
          type="company"
          size="small"
          sizeConfined="medium"
          src={company?.logo}
        />
        <Title noMargin size="large">
          {title}
        </Title>
        <StickyMainActions
          application={application}
          job={job}
          bookmarkState={bookmarkState}
        />
      </Header>
    </Container>
  );
};
